import { Ban, Repeat, CalendarOff } from 'lucide-vue';
import { getRestriktionTypeConfig } from './restriktionen.constants.js';

// Stellt Komponenten die Typ-Konfiguration einer Restriktion (Label, Icon, Farben) im Template bereit
export default {
  components: {
    Ban,
    Repeat,
    CalendarOff,
  },
  methods: {
    typeConfig(type) {
      return getRestriktionTypeConfig(type);
    },
  },
};
